import React, {useEffect, useState} from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Collapse,
    TableRow,
    TableCell,
} from '@material-ui/core';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import {Skeleton} from "@material-ui/lab";
import SortableTable from "../../shared/Tables/SortableTable";
import {NavLink} from "react-router-dom";

const MergeRelations = ({team, open, fetching, mergedIn, ...props}) => {

    const [expandMerges, setExpandMerges] = useState(open);
    const [relations, setRelations] = useState([]);


    useEffect(() => {
        setRelations(props.mergeRelations);
    }, [props.mergeRelations])

    const toggleExpandNews = () => {
        setExpandMerges(!expandMerges);
    }

    return (
        <React.Fragment>
            <Card style={{marginTop: '24px'}}
            >
                <CardHeader className='cursor-pointer' title={
                    <span>
              <span>Merge Relations</span>
              <span className='float-right'>
                {
                    expandMerges ? <ExpandLess/> : <ExpandMore/>
                }
              </span>
            </span>
                } onClick={toggleExpandNews}
                />
                <Divider/>
                <CardContent style={{padding: `${expandMerges ? '20px' : 0}`, overflowY: 'auto'}}>
                    <Collapse in={expandMerges}>
                        {
                            fetching ? (<Skeleton animation='pulse' variant='rect' height='100px' width='100%' component='div'/>) :
                                (
                                    <>
                                        {mergedIn && (
                                            <div style={{marginBottom: '24px'}}>
                                                <strong>Merged Into Team:</strong>{" "}

                                                <span>
                                                     <NavLink
                                                         key={mergedIn.id}
                                                         to={{
                                                             pathname:`/admin/live_data/private_wealth_teams`,
                                                             search: `?team_id=${mergedIn.id}`,
                                                             state: {from: `/admin/live_data/private_wealth_teams`, fromSearch: `team_id=${team.id}`}
                                                         }}
                                                     >
                                                    {`${mergedIn.team_name} (ID: ${mergedIn.id})`}
                                                    </NavLink>
                                                </span>
                                            </div>
                                        )}
                                        {relations.length > 0 && (
                                            <>
                                                <div style={{margin: '20px 0'}}>Teams Combined Into This Team</div>
                                            <SortableTable
                                                headCells={[
                                                    {id: 'id', numeric: false, disablePadding: false, label: 'Team ID', sortable: false},
                                                    {id: 'team_name', numeric: false, disablePadding: false, label: 'Name', sortable: false},
                                                    {id: 'crd_id', numeric: false, disablePadding: false, label: 'Parent Firm', sortable: false},
                                                    {id: 'merged_at', numeric: false, disablePadding: false, label: 'Merged At'},
                                                ]}
                                                rows={relations}
                                                RowRenderer={
                                                    (row, _isSelected, index, _handleCheck) => (<TableRow
                                                        hover
                                                        tabIndex={-1}
                                                        key={row.id}
                                                        style={{cursor: "pointer"}}
                                                        onClick={(event) => (row.id)}
                                                    >
                                                        <TableCell>
                                                            {row.id}
                                                        </TableCell>
                                                        <TableCell>
                                                            <NavLink
                                                                key={row.id}
                                                                to={{
                                                                    pathname:`/admin/live_data/private_wealth_teams`,
                                                                    search: `?team_id=${row.id}`,
                                                                    state: {from: `/admin/live_data/private_wealth_teams`, fromSearch: `team_id=${team.id}`}
                                                                }}
                                                            >
                                                                {`${row.team_name}`}
                                                            </NavLink>
                                                        </TableCell>

                                                        <TableCell>
                                                            {row.crd_id}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.merged_at}
                                                        </TableCell>
                                                    </TableRow>)
                                                }
                                            />
                                            </>
                                        )}
                                    </>
                                )
                        }
                    </Collapse>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default MergeRelations;